/**
 * The server's stand-in avatars (DEFAULT_AVATAR in app/settings/base.py) that are too dark for a
 * dark page. An element showing one gets these classes, and styles/default-avatars.css draws the
 * svg in the theme's colour instead. The url alone tells: it is the default exactly when
 * uses_default_avatar is set and uses_generated_avatar is not, and not every serializer sends those.
 */
const DEFAULT_AVATARS = {
    'images/icons/np_tasks_1302542_2D2D2D.png': 'task',
    'images/new_daschboard_icons/2020/mygoals.png': 'goal',
};

function defaultAvatarKind (url) {
    if (!url) {
        return undefined;
    }
    // with or without the site's domain in front
    const path = Object.keys(DEFAULT_AVATARS).find(p => url.endsWith(p));
    return path && DEFAULT_AVATARS[path];
}

function defaultAvatarClass (url) {
    const kind = defaultAvatarKind(url);
    return kind ? ['default-avatar', `default-avatar_${kind}`] : [];
}

export {defaultAvatarKind, defaultAvatarClass};
